'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .ant-menu-submenu-arrow {\n    &::before,\n    &::after {\n      background: ", "!important;\n    }\n  }\n\n  .ant-menu-submenu-title {\n        color: black !important\n\n        &::after {\n          content: \"\";\n          height: 100%;\n          left: 0;\n          border-right: none;\n          // border-left: 3px solid white;\n          position: absolute;\n        }\n      }\n\n\n  &.ant-menu-submenu-selected {\n      .ant-menu-submenu-title {\n        background: white !important;\n        color: black\n\n        &::after {\n          content: \"\";\n          height: 100%;\n          left: 0;\n          border-right: none;\n          // border-left: 3px solid white;\n          position: absolute;\n        }\n      }\n    }\n\n    @media (max-width: 768px) {\n\n    &.ant-menu-submenu-selected {\n      .ant-menu-submenu-title {\n        background: transparent !important; \n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _reactRouterDom = require('react-router-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icons = require('../components/Icons');

var _Icons2 = _interopRequireDefault(_Icons);

var _IsUser = require('../utils/user/IsUser');

var _IsUser2 = _interopRequireDefault(_IsUser);

var _userStatus = require('../constants/userStatus');

var _userStatus2 = _interopRequireDefault(_userStatus);

var _checkStatusPermission = require('../utils/checkStatusPermission');

var _checkStatusPermission2 = _interopRequireDefault(_checkStatusPermission);

var _screenBreakpoints = require('../constants/screenBreakpoints');

var _screenBreakpoints2 = _interopRequireDefault(_screenBreakpoints);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SubMenu = _antd.Menu.SubMenu;
var StyledSubMenu = (0, _styledComponents2.default)(SubMenu)(_templateObject(), function (props) {
  return props.arrowColor;
});

exports.default = function (sidebarMenu) {
  return function (WrappedComponent) {
    var RenderMenu =
    /*#__PURE__*/
    function (_react$Component) {
      _inherits(RenderMenu, _react$Component);

      function RenderMenu() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, RenderMenu);

        var _temp;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RenderMenu)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
          menuMode: 'vertical'
        }, _this.checkSidebarMode = function () {
          return window.innerWidth > _screenBreakpoints2.default.md ? 'inline' : 'vertical-right';
        }, _this.setMenuMode = function () {
          var mode = _this.checkSidebarMode();

          if (mode !== _this.state.menuMode) {
            _this.setState({
              menuMode: mode
            });
          }
        }, _this.findSelectedKeys = function () {
          var _this$props = _this.props,
              userType = _this$props.userType,
              pathname = _this$props.pathname;
          var defaultOpenKeys = [];
          var selectedKeys = [];

          if (userType && pathname) {
            var menu = sidebarMenu[userType.toLowerCase()];

            for (var i = 0; i < menu.length; i++) {
              if (menu[i].subMenu && pathname.search(menu[i].inPath) !== -1) {
                var key = (i + 1) * 100;
                defaultOpenKeys.push("sub".concat(key));

                for (var j = 0; j < menu[i].items.length; j++) {
                  if (pathname.search(menu[i].items[j].linkTo) !== -1) {
                    selectedKeys.push("".concat(key + j + 1));
                  }
                }

                break;
              }

              if (!menu[i].subMenu && pathname.search(menu[i].linkTo) !== -1) {
                selectedKeys.push("".concat(i + 1));
              }
            }
          }

          return {
            selectedKeys: selectedKeys,
            defaultOpenKeys: defaultOpenKeys
          };
        }, _this.renderSubMenuList = function (item, i) {
          var _this$props2 = _this.props,
              permissions = _this$props2.permissions,
              theme = _this$props2.theme;
          var menuMode = _this.state.menuMode;
          var key = (i + 1) * 100;
          var subMenuItems = [];
          var iconStyles = {
            color: theme.platformPrimary
          };

          var subMenuTitle = _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(item.IconComponent, {
            style: iconStyles
          }), _react2.default.createElement('span', {
            className: 'submenu-item-name'
          }, item.name));

          item.items.forEach(function (subMenuItem, j) {
            if (permissions.includes(subMenuItem.permissionName)) {
              subMenuItems.push(_react2.default.createElement(_antd.Menu.Item, {
                key: key + j + 1
              }, _react2.default.createElement(_reactRouterDom.Link, {
                to: subMenuItem.linkTo
              }, _react2.default.createElement('span', null, subMenuItem.name))));
            }
          });
          var submenuWithTitle = subMenuItems.slice();
          return subMenuItems.length > 0 ? _react2.default.createElement(StyledSubMenu, {
            key: "sub".concat(key),
            arrowColor: theme.platformPrimary,
            title: subMenuTitle
          }, submenuWithTitle) : null;
        }, _this.renderMenuList = function () {
          var _this$props3 = _this.props,
              userType = _this$props3.userType,
              permissions = _this$props3.permissions,
              theme = _this$props3.theme,
              dealManagementEnabled = _this$props3.dealManagementEnabled; // Remove TAB_REPORTS from permissions if dealManagementEnabled is false

          var effectivePermissions = dealManagementEnabled !== undefined && permissions && dealManagementEnabled === false ? permissions.filter(function (p) {
            return p !== 'TAB_REPORTS';
          }) : permissions;
          var iconStyles = {
            color: theme.platformPrimary,
            fill: theme.platformPrimary,
            width: '16px',
            height: '16px'
          };

          if (!userType) {
            return null;
          }

          return sidebarMenu[userType.toLowerCase()].map(function (item, i) {
            if (item.subMenu) {
              return _this.renderSubMenuList(item, i);
            }

            if (effectivePermissions.includes(item.permissionName)) {
              return _react2.default.createElement(_antd.Menu.Item, {
                key: i + 1
              }, _react2.default.createElement(_reactRouterDom.Link, {
                to: item.linkTo
              }, _react2.default.createElement(item.IconComponent, {
                style: iconStyles
              }), _react2.default.createElement('span', {
                className: 'submenu-item-name'
              }, item.name)));
            }

            return null;
          });
        }, _this.renderDisabledPersonalProjects = function (key) {
          return _react2.default.createElement(_antd.Menu.Item, {
            key: key,
            className: 'ant-menu-item-disabled',
            'aria-disabled': 'true'
          }, _react2.default.createElement(_reactRouterDom.Link, {
            disabled: true,
            to: ''
          }, _react2.default.createElement(_Icons2.default.myProject, {
            className: 'submenu-item-icon',
            style: {
              marginRight: 10
            }
          }), _react2.default.createElement('span', {
            className: 'submenu-item-name'
          }, 'My Projects')));
        }, _temp));
      }

      _createClass(RenderMenu, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.setMenuMode();
          window.addEventListener('resize', this.setMenuMode);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener('resize', this.setMenuMode);
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props4 = this.props,
              userType = _this$props4.userType,
              userStatus = _this$props4.userStatus,
              permissions = _this$props4.permissions;
          var menuList = this.renderMenuList();
          var selectedKeys = this.findSelectedKeys();
          var isUser = new _IsUser2.default(userType);

          if (isUser.issuer && !(0, _checkStatusPermission2.default)(userStatus, _userStatus2.default.ACCOUNT_CREATED) && !permissions.includes('TAB_MY_PROJECTS')) {
            menuList.push(this.renderDisabledPersonalProjects(menuList.length + 1));
          }

          return menuList && _react2.default.createElement('div', null, _react2.default.createElement(WrappedComponent, _extends({
            menuList: menuList,
            defaultValues: selectedKeys
          }, this.props)));
        }
      }]);

      return RenderMenu;
    }(_react.Component);

    RenderMenu.defaultProps = {
      nda: null,
      ndaUrl: null,
      signNDA: null,
      isSignNDA: null,
      ndaSigned: null,
      cvCreated: null
    };
    return (0, _styledComponents.withTheme)(RenderMenu);
  };
};